import { useQuery } from "@apollo/client";
import { PARLORS } from "../helpers/query.gql";
import { useMemo } from "react";

export default (variables = {}) => {
  const { data, loading, error } = useQuery(PARLORS, {variables});

  const parlors = useMemo(() => data?.parlors ?? [], [data]);

  return {
    loading,
    error,
    parlors,
  };
};
